<template>
    <li>
        <a
            class="footer-link"
            :href="url"
            :target="target"
            v-html="text"
        />
    </li>
</template>

<script>
export default {
    name: 'FooterLinkListItem',
    props: {
        linkModel: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        url() {
            return this.linkModel?.Url;
        },
        target() {
            return this.linkModel?.Target;
        },
        text() {
            return this.linkModel?.Text;
        },
    }
};
</script>
